<template src='./dateRange.pug' lang='pug'></template>

<script>
import Datepicker from 'vuejs-datepicker'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import idioma from '../../../../build/language/index'
import customValidator from '../../../utils/customValidator.js'

export default {
  name: 'DateRange',

  components: {
    Datepicker,
    ButtonPrimary
  },

  props: {
    value: {
      type: Object
    },
    initialFromDate: {
      type: Date
    },
    initialToDate: {
      type: Date
    },
    maxRange: {
      type: Number
    },
    customPeriodMessage: {
      type: String,
      default: null
    },
    customDatesMessage: {
      type: String,
      default: null
    },
    finalDateDisableFrom: {
      type: Date,
      default () {
        return new Date()
      }
    },
    disableDateRange: {
      type: Boolean,
      default: false
    },
    displayLabel: {
      type: Boolean,
      default: true
    },
    displayAction: {
      type: Boolean,
      default: false
    },
    action: {
      type: Function,
      default: null
    }
  },

  data () {
    return {
      clients: [],
      idioma: idioma,
      fromDate: this.initialFromDate,
      toDate: this.initialToDate,
      message: null,
      invalid: false,
      inputFrom: null,
      inputTo: null
    }
  },

  computed: {
    datePickerLanguage () {
      return this.idioma.getDatePickerLanguageObject()
    },

    errorMessage () {
      return this.message
    },

    isInvalid () {
      return this.invalid
    },

    endDateDisableFrom () {
      return this.finalDateDisableFrom ? this.finalDateDisableFrom : new Date()
    }
  },

  methods: {
    input () {
      this.invalid = !this.validate()
      // Retorna um objeto toda vez que o período é alterado
      // Setando a data inicial para as 00:00, e a data final para 24:00
      this.$emit('input', {
        fromDate: this.resetHours(this.fromDate, false),
        toDate: this.resetHours(this.toDate, true),
        invalid: this.invalid
      })
    },

    validate () {
      if (!this.isDateValid(this.inputFrom)) {
        this.fromDate = this.initialFromDate
      }

      if (!this.isDateValid(this.inputTo)) {
        this.toDate = this.initialToDate
      }

      this.fromDate = new Date(this.resetHours(this.fromDate, false))
      this.toDate = new Date(this.resetHours(this.toDate, true))

      let isDateRangeValid = true
      let timeDiff = Math.abs(this.fromDate.getTime() - this.toDate.getTime())
      let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

      if (diffDays > this.maxRange) {
        this.message = this.$t('dateRange.validacao.periodoMaximo', {dias: this.maxRange})
        isDateRangeValid = false
      }

      if (this.fromDate > this.toDate) {
        this.message = this.$t('dateRange.validacao.dataInicialMaiorFinal')
        isDateRangeValid = false
      }
      return isDateRangeValid
    },

    isDateValid (input) {
      return input.value.length === 10 && customValidator.isValidDate(input.value)
    },

    resetHours (date, endOfTheDay) {
      if (typeof date === 'number') {
        date = new Date(date)
      }

      if (endOfTheDay) {
        return date.setHours(23, 59, 59, 999)
      }
      return date.setHours(0, 0, 0, 0)
    }
  },

  created () {
    this.fromDate = this.initialFromDate
    this.toDate = this.initialToDate

    this.$emit('input', {
      fromDate: this.resetHours(this.fromDate, false),
      toDate: this.resetHours(this.toDate, true),
      invalid: this.invalid
    })
  },

  mounted () {
    this.inputFrom = document.getElementById('datePickerFromDate')
    this.inputFrom.setAttribute('autocomplete', 'off')

    this.inputTo = document.getElementById('datePickerToDate')
    this.inputTo.setAttribute('autocomplete', 'off')
  }
}
</script>

<style>
.datepicker-input {
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 5px;
  display: inline;
  margin-left: 10px;
}

.datepicker-wrapper {
  display: inline !important;
}

.datepicker-wrapper div:first-child {
  display: inline !important;
}

.wrapperClass div:first-child {
  display: inline !important;
}

.wrapperClass {
  display: inline !important;
}

.fix-aligment {
  padding-left: 0;
  padding-top: 4px;
}

.disable-datepicker {
  background-color: #f8f8f8;
  cursor: default;
}

/* DatePicker*/
.date-picker {
  border: none;
  height: 28px;
  width: 100px;
}

.month-picker {
  border: none;
  height: 28px;
  width: 130px;
}

.vdp-datepicker {
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 11px 8px 10px 8px;
  margin-right: 5px;
}

.vdp-datepicker-margin-top {
  margin-top: 10px;
}

.second-date-picker {
  margin-left: 10px;
}

.second-date-picker .vdp-datepicker__calendar {
  margin-left: 180px;
}

.vdp-datepicker__calendar {
  padding: 5px;
}

.vdp-datepicker__calendar header span {
  font-family: 'Inter', sans-serif;
font-weight: 700;
}

.vdp-datepicker__calendar .cell {
  height: 35px !important;
  line-height: 35px !important;
}

.vdp-datepicker__calendar .cell.day-header {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  color: #8c8c8c;
  height: 35px;
  line-height: 35px;
}

.vdp-datepicker__calendar .cell.selected,
.vdp-datepicker__calendar .cell.selected.highlighted,
.vdp-datepicker__calendar .cell.selected:hover {
  background: #40b9bb !important;
  color: #fff !important;
  border-radius: 5px;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #40b9bb !important;
  border-radius: 5px;
}

.vdp-datepicker__calendar .disabled {
  color: #8c8c8c !important;
}

.vdp-datepicker__calendar .cell.today {
  background-image: url('../../../assets/icones_app/today-signal.png') !important;
  background-repeat: no-repeat !important;
  background-position: 30px 20px !important;
}

.vdp-datepicker__calendar {
  z-index: 3!important;
}

.input-button>button {
  margin: 24px 0 0 0;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 36px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// DateRange.vue?01e21dc3